module.exports = __webpack_public_path__ + "static/media/HO16.0acd71ce.png";